import React, { useEffect, useState } from 'react'
import { Pagination as PaginationB } from 'react-bootstrap';
import { formatNumber } from '../utils/utils';

function Pagination({
    current_pag = 0,
    total_pages = 0,
    length = 3,
    onPage
}) {

    const START = 0;
   
    const [last_pag,set_last_page] = useState(START);

    const [get_current_pag,set_current_pag] = useState(START);

    const [range_page,set_range_page] = useState([]);

    const [more_end,set_more_end] = useState(false);
    const [more_start,set_more_start] = useState(false);

    useEffect(()=> set_last_page(total_pages - 1),[total_pages]);
    
    useEffect(()=> set_current_pag(current_pag),[current_pag]);
    
    useEffect(()=>{

        const {start,spare_start} = calculate_length_start(current_pag);
        const {end,spare_end} = calculate_length_end(current_pag);

        const length_start = start - spare_end >= 0 ? start - spare_end : 0;
        const length_end = end + spare_start <= last_pag ? end + spare_start : last_pag;

        const range = [];

        set_more_end(()=> last_pag > length_end);

        set_more_start(()=> length_start > 0);

        for(var i = length_start; i<=length_end;i++){
            range.push({number:i,current: i === current_pag});
        }

        set_range_page(()=> range);
        
    // eslint-disable-next-line    
    },[get_current_pag,last_pag]);

    const calculate_length_start = (current_pag) =>{

        if(current_pag - length < 0)
        {
            const spare = (current_pag - length) * -1;
            return {
                spare_start:spare,
                start:0
            };
        }

        return {
            spare_start:0,
            start:current_pag - length
        };
    }

    const calculate_length_end = (current_pag) =>{

        if(current_pag + length > last_pag)
        {
            const spare = (current_pag + length) - last_pag;
            return {
                spare_end:spare,
                end:last_pag
            };
        }

        return {
            spare_end:0,
            end:current_pag + length
        }
    }

    return (
        <PaginationB>
          <PaginationB.First hidden={(get_current_pag - 1) < 0} onClick={()=> onPage(START)} />
          <PaginationB.Prev hidden={(get_current_pag - 1) < 0} onClick={()=> onPage(get_current_pag - 1 )} />
          <PaginationB.Ellipsis hidden={!more_start} />
            {
                range_page.map(pag =>{
                    return (<PaginationB.Item key={pag.number} active={pag.current} onClick={()=> pag.current ? ()=>{} : onPage(pag.number)} >{formatNumber(pag.number + 1)}</PaginationB.Item>);
                })
            }

          <PaginationB.Ellipsis hidden={!more_end} />
          <PaginationB.Next hidden={(get_current_pag + 1) > last_pag } onClick={()=> onPage(get_current_pag + 1)}/>
          <PaginationB.Last hidden={(get_current_pag + 1) > last_pag } onClick={()=> onPage(last_pag)}/>
        </PaginationB>
      );
}

export default Pagination